import { render } from "./ContentToggle.vue?vue&type=template&id=5039fcf8"
import script from "./ContentToggle.vue?vue&type=script&lang=js"
export * from "./ContentToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__